<script lang="ts" setup>
import { Button, Icon } from '@brighterly/lib-lumee-ui'

import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'

defineOptions({
  name: 'LocalSharePlaceholder',
})

const { toggleScreenShare } = useTracksLiveKit()

const handleStop = (): void => {
  void toggleScreenShare()
}
</script>

<template>
  <div class="local-share-placeholder">
    <span class="local-share-placeholder__icon">
      <Icon
        name="arrow-up-from-bracket"
        size="md"
        color="inherit"
      />
    </span>
    <p class="local-share-placeholder__title btly-text-heading-m">
      You are sharing your screen
    </p>
    <Button
      view="destructive"
      size="md"
      leading-icon="xmark"
      text="Stop screen share"
      @click="handleStop"
    />
  </div>
</template>

<style scoped lang="scss" src="./LocalSharePlaceholder.scss" />
